import { render, staticRenderFns } from "./customer-group.vue?vue&type=template&id=7df4846e&scoped=true&"
import script from "./customer-group.vue?vue&type=script&lang=js&"
export * from "./customer-group.vue?vue&type=script&lang=js&"
import style0 from "./customer-group.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customer-group.vue?vue&type=style&index=1&id=7df4846e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4846e",
  null
  
)

export default component.exports